import { BudgetLineItemType } from "../enums/budget-line-item-type";

type NullableString = string | undefined | null;

const htmlNewLine = '<br/>';

function isNullOrEmpty(s: NullableString) {
    return (s?.trim()?.length ?? 0) === 0;
}

function convertCharNewLinesToHtml(s: NullableString) {
    return s?.replace(/\r\n/g, htmlNewLine).replace(/\r/g, htmlNewLine).replace(/\n/g, htmlNewLine);
}

function isInString(stringToSearch: NullableString, stringToSearchFor: NullableString, caseSensitive = false) {
    const sToSearch = caseSensitive ? stringToSearch : stringToSearch?.toLowerCase();
    const sToSearchFor = caseSensitive ? stringToSearchFor : stringToSearchFor?.toLowerCase();

    return (isNullOrEmpty(sToSearch) && isNullOrEmpty(sToSearchFor)) ||
           (sToSearchFor !== null && sToSearchFor !== undefined && sToSearch?.includes(sToSearchFor) === true);
}

function isInList(list: NullableString[], s: NullableString, caseSensitive = false) {
    const found = list.find(stringInList => isInString(stringInList, s, caseSensitive));
    return !isNullOrEmpty(found);
}

function amountDisplayText(amount: number, accountType?: string): string {
    const currencyFormat = new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
      });
      const amountFormat = currencyFormat.format(Math.abs(amount));


    if (accountType === BudgetLineItemType.Income || +amount < 0) {
      return `(${amountFormat})`;
    }
    return amountFormat;
}

export const StringUtility = {
    isNullOrEmpty,
    convertCharNewLinesToHtml,
    isInString,
    isInList,
    amountDisplayText
};
